@if (nonProdVersionDisplay) {
  <a href="javascript: void(0);" routerLink="/debug">
    {{ nonProdVersionDisplay }}
  </a>
}
